import React, { useState, useRef, useEffect } from "react";
import CommentCount from "../comment-count";
import SocialMediaShare from "../../molecules/social-media-share";
import "./bookmark-comment-share-butons.m.css";
import { useDispatch, useSelector } from "react-redux";
import { get, throttle } from "lodash";
import { getUserDetails, putUserDetails } from "../../helper/utils";
import { setUserDetails } from "../../store/actions";
import FillBookmark from "../../atoms/other-icons/FillBookmark";
import Share from "../../atoms/other-icons/Share";

function BookmarkCommentShareButtons({ story, isPVExclusive }) {
  const { id, url, headline } = story;
  const [showSocialShare, setShowSocialShare] = useState(false);
  const [showSigninToBookMark, setShowSigninToBookmark] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  const liveBlogTemplate = story["story-template"] == "live-blog";

  const dispatch = useDispatch();

  const [isBookmarked, setIsBookmarked] = useState(false);
  const shareRef = useRef();
  const bookmarkRef = useRef();

  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  function socialShareHandler() {
    setShowSocialShare((prevShowSocialShare) => !prevShowSocialShare);
  }

  const isAlreadyBookmarked = userdetails?.metadata?.savedArticles?.some((article) => article?.id === id);

  useEffect(() => {
    if (isAlreadyBookmarked) {
      setIsBookmarked(true);
    }
  }, [isBookmarked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSocialShare && !shareRef.current.contains(event.target)) {
        setShowSocialShare(false);
      }
      if (bookmarkRef.current && !bookmarkRef.current.contains(event.target)) {
        setShowSigninToBookmark(false);
      }
    };
    document.addEventListener("mousedown", throttle(handleClickOutside, 250));

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSocialShare]);

  const addBookmarkHandler = () => {
    if (isUserLogin) {
      let localUserData;
      const user = window?.localStorage?.getItem("user");
      if (user !== "undefined") {
        if (typeof user === "string" && user.trim() !== "") {
          localUserData = JSON.parse(user);
        }
      }
      const userSavedArticles = localUserData?.metadata?.savedArticles ? localUserData?.metadata?.savedArticles : [];

      if (userSavedArticles?.length === 100) {
        userSavedArticles.shift();
      }
      const updateData = {
        savedArticles: [
          ...userSavedArticles,
          {
            id,
            headline,
            "hero-image-s3-key": story["hero-image-s3-key"],
            "hero-image-metadata": story["hero-image-metadata"],
            url,
            "story-template": story["story-template"],
            "published-at": story["published-at"]
          }
        ]
      };

      const savedArticlesLength = updateData?.savedArticles?.length;
      dispatch(setUserDetails({ ...userdetails, metadata: { ...userdetails?.metadata, ...updateData } }));
      window.localStorage.setItem(
        "user",
        JSON.stringify({ ...localUserData, metadata: { ...localUserData?.metadata, ...updateData } })
      );
      putUserDetails(updateData);
      localStorage.setItem("bookmarksLength", savedArticlesLength);
      setIsBookmarked(true);
    } else {
      setShowSigninToBookmark(!showSigninToBookMark);
    }
  };

  const removeBookmarkHandler = () => {
    let localUserData;
    const user = window?.localStorage?.getItem("user");
    if (user !== "undefined") {
      if (typeof user === "string" && user.trim() !== "") {
        localUserData = JSON.parse(user);
      }
    }

    const updatedBookmarksArray = localUserData?.metadata?.savedArticles?.filter((article) => {
      return article?.id !== id;
    });
    const updateData = { savedArticles: updatedBookmarksArray };
    const savedArticlesLength = updateData?.savedArticles?.length;
    localStorage.setItem("bookmarksLength", savedArticlesLength);
    dispatch(setUserDetails({ ...userdetails, metadata: { ...userdetails?.metadata, ...updateData } }));
    window.localStorage.setItem(
      "user",
      JSON.stringify({ ...localUserData, metadata: { ...localUserData?.metadata, ...updateData } })
    );
    putUserDetails(updateData);
    setIsBookmarked(false);
  };

  const [redirectURL, setRedirectUrl] = useState("");
  useEffect(() => {
    setRedirectUrl(window.location.href);
    const accessToken = window.localStorage.getItem("access_token");
    setAccessToken(accessToken);
  }, []);
  useEffect(() => {
    let bookmarkStory;
    const tempBookmarkStory = window?.localStorage?.getItem("tempBookmarkStory");
    if (tempBookmarkStory !== "undefined") {
      if (typeof tempBookmarkStory === "string" && tempBookmarkStory.trim() !== "") {
        bookmarkStory = JSON.parse(tempBookmarkStory);
      }
    }
    if (accessToken && bookmarkStory?.id && userdetails?.metadata) {
      let localUserData;
      const user = window?.localStorage?.getItem("user");
      if (user !== "undefined") {
        if (typeof user === "string" && user.trim() !== "") {
          localUserData = JSON.parse(user);
        }
      }
      const userSavedArticles = localUserData?.metadata?.savedArticles ? localUserData?.metadata?.savedArticles : [];

      if (userSavedArticles?.length === 100) {
        userSavedArticles.shift();
      }
      const updateData = {
        savedArticles: [...userSavedArticles, bookmarkStory]
      };
      const savedArticlesLength = updateData?.savedArticles?.length;
      dispatch(setUserDetails({ ...userdetails, metadata: { ...userdetails?.metadata, ...updateData } }));
      window.localStorage.setItem(
        "user",
        JSON.stringify({ ...localUserData, metadata: { ...localUserData?.metadata, ...updateData } })
      );
      putUserDetails(updateData);
      getUserDetails();
      localStorage.setItem("bookmarksLength", savedArticlesLength);
      localStorage.removeItem("tempBookmarkStory");
      setIsBookmarked(true);
    }
  }, [accessToken, userdetails]);

  const signinHandler = () => {
    if (window) {
      window.dataLayer.push({
        event: "SSO_Page_Open"
      });
    }
    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;

    window.localStorage.setItem(
      "tempBookmarkStory",
      JSON.stringify({
        id,
        headline,
        "hero-image-s3-key": story["hero-image-s3-key"],
        url,
        "story-template": story["story-template"],
        "published-at": story["published-at"]
      })
    );
  };

  return (
    <div
      styleName={`icons-wrapper ${liveBlogTemplate ? "liveBlog-icons-wrapper" : ""} ${isPVExclusive ? "exclusive-icons-wrapper" : ""
        } `}
    >
      <div ref={bookmarkRef}>
        {isBookmarked ? (
          <button styleName="bookmark-icon" onClick={removeBookmarkHandler}>
            <FillBookmark color="black" height="20px" width="20px" />
          </button>
        ) : (
          <button styleName="bookmark-icon" onClick={addBookmarkHandler}>
            <FillBookmark height="20px" width="20px" />
          </button>
        )}
        {showSigninToBookMark && (
          <div
            styleName={`signinToBookmark ${liveBlogTemplate ? "live-siginToBookmark" : ""}  ${isPVExclusive ? "exclusive-sigininToBookmark" : ""
              } `}
          >
            <span onClick={signinHandler}>Sign in</span> <span>to bookmark this story</span>
            <span styleName="triangle"></span>
          </div>
        )}
      </div>
      <div>
        {!liveBlogTemplate && (
          <CommentCount stickyByline={true} story={story} showCommentText={false} renderPortal={true} />
        )}
      </div>
      <div ref={shareRef}>
        <button onClick={socialShareHandler} styleName="share-icon">
          <Share color="black" width="20" height="20" />
        </button>
        {showSocialShare && (
          <div styleName={`social-icons ${isPVExclusive ? "exclusive-social-icons" : ""} `}>
            <span styleName="triangle"></span>
            <SocialMediaShare story={story} />
          </div>
        )}
      </div>
    </div>
  );
}

export default BookmarkCommentShareButtons;
